/* Dải reviews — chạy bằng Splide, KHÔNG bằng cuộn native.
 *
 * VÌ SAO ĐỔI CƠ CHẾ, sau bảy lần vá không dứt.
 *
 * Bản cũ là `overflow-x:auto` + `scroll-snap` + JS nhân ba bộ thẻ rồi dịch
 * `track.scrollLeft` một bộ mỗi khi trôi khỏi bộ giữa. Cả bảy lần sửa đều đi tìm
 * một THỜI ĐIỂM an toàn để dịch. Không có thời điểm nào an toàn:
 *
 *   - Đà lướt trên di động do luồng compositor chạy, không phải JS. JS không có
 *     cách nào đọc được trạng thái đà đó.
 *   - Ghi `scrollLeft` giữa lúc còn đà thì Chrome dời vị trí nhưng cú lướt vẫn
 *     giữ đích cũ, nên nó trượt thêm sang thẻ khác; Safari thì cắt đà.
 *   - `scrollend` chỉ báo lúc đã dừng hẳn, không giúp gì cho ca phải dịch GIỮA
 *     một cú vuốt dài.
 *
 * Splide kéo track bằng `transform: translateX` với vật lý riêng, không đụng
 * vào cuộn native (đo bản 4.1.4: `translate` 6 lần, `scrollLeft` 0 lần). Phép
 * nhảy vòng vì thế chỉ là một lần đổi transform giữa hai khung hình — vô hình
 * theo thiết kế, không phải nhờ canh thời điểm. Đây cũng là thư viện Brickwar2
 * dùng cho carousel trong theme của họ.
 *
 * Mũi tên và chấm vẫn dựng bằng tay theo đúng markup `.rvnav` cũ, để nguyên bộ
 * CSS đã tinh chỉnh nhiều vòng thay vì phải tạo hình lại `.splide__arrows` và
 * `.splide__pagination`.
 */
(function () {
  'use strict';

  /* Hai dải dùng CHUNG bộ khởi tạo này. Thêm dải mới thì thêm một dòng ở đây,
     đừng viết bản Splide thứ hai — mọi con số về cảm giác chuyển thẻ (speed,
     easing, flickMaxPages) đã tinh chỉnh nhiều vòng, tách ra là lệch ngay. */
  var DAI = [
    { goc: '.lb-demo .rvsl', nhan: 'Review', rieng: null },
    /* Collection: 3 xe. `type:'slide'` chứ KHÔNG 'loop' — loop cần đủ thẻ để
       nhân bản, mà desktop đã hiện cả 3 nên vòng lặp vô nghĩa và Splide sẽ dựng
       clone thừa. Desktop perPage 3 là vừa hết, tự khắc không kéo được; điện
       thoại về 1 thẻ có hé thẻ sau, giống dải reviews. */
    { goc: '.lb-demo .lb-cgrid', nhan: 'Product', rieng: { type: 'slide', perPage: 3 } }
  ];
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ' +
                'aria-hidden="true"><polyline points="%s"/></svg>';

  /* Bề rộng thẻ khớp đúng ba bậc của bản cũ, đọc từ legendbrix-demo-home.css:
   *   trên 920px : ba thẻ, gap 20px   -> perPage 3
   *   tới 920px  : một thẻ 58%        -> perPage 1, hé 42% thẻ sau
   *   tới 560px  : một thẻ 86%        -> perPage 1, hé 14% thẻ sau
   * Splide tính bề rộng thẻ từ `perPage` và `padding`, nên ba luật `.rvsl > *`
   * bên CSS đã gỡ đi — để lại thì hai bên tranh nhau. */
  function tuyChon(rieng) {
    var o = {
      type: 'loop',
      perPage: 3,
      gap: '20px',
      arrows: false,
      pagination: false,
      drag: true,

      /* BA SỐ NÀY ĐỌC TỪ CẤU HÌNH THẬT CỦA BRICKWAR2, không phải tự đặt.
         Họ chạy Slick với `"speed": 400, "cssEase": "linear", "slidesToScroll": 1`.

         `easing` là chỗ gây cảm giác "gấp". Mặc định của Splide là
         `cubic-bezier(.25,1,.5,1)` — ease-out rất mạnh: t=0.1 đã đi được 35%
         quãng đường, t=0.3 đã 75%. Mắt đọc ra thành một cú giật rồi trôi chậm.
         `linear` giữ vận tốc đều suốt 400ms nên chuyển thẻ liền mạch.

         `flickMaxPages: 1` ứng với `slidesToScroll: 1` của họ: một cú vuốt đi
         đúng MỘT thẻ, dù vuốt mạnh cỡ nào. Không có nó thì cú vuốt mạnh nhảy
         vài thẻ một lúc — cũng đọc ra là "gấp".

         `flickPower` trả về mặc định 600. Vòng trước tôi hạ xuống 300 mà không
         có căn cứ nào; giờ số thẻ mỗi cú vuốt đã do flickMaxPages chặn rồi. */
      speed: 400,
      easing: 'linear',
      flickPower: 600,
      flickMaxPages: 1,
      breakpoints: {
        920: { perPage: 1, gap: '14px', padding: { left: '16px', right: '42%' } },
        560: { perPage: 1, gap: '14px', padding: { left: '16px', right: '14%' } }
      }
    };
    /* Ghi đè ở tầng NGOÀI cùng, không đệ quy vào `breakpoints`: hai dải dùng
       chung đúng ba bậc màn hình, chỉ khác nhau ở desktop. */
    if (rieng) { for (var k in rieng) { o[k] = rieng[k]; } }
    return o;
  }

  function nut(diem, nhan, chay) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rvnav__b';
    b.setAttribute('aria-label', nhan);
    b.innerHTML = CHEVRON.replace('%s', diem);
    b.addEventListener('click', chay);
    return b;
  }

  function dungDieuKhien(sp, goc, soThe, nhan) {
    var dots = document.createElement('div');
    dots.className = 'lb-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', nhan + 's');

    function danhDau(i) {
      Array.prototype.forEach.call(dots.children, function (b, k) {
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }

    for (var i = 0; i < soThe; i++) {
      (function (k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', nhan + ' ' + (k + 1) + ' / ' + soThe);
        b.addEventListener('click', function () { sp.go(k); });
        dots.appendChild(b);
      })(i);
    }

    var hang = document.createElement('div');
    hang.className = 'rvnav';
    hang.appendChild(nut('15 18 9 12 15 6', 'Previous ' + nhan.toLowerCase(), function () { sp.go('<'); }));
    hang.appendChild(dots);
    hang.appendChild(nut('9 18 15 12 9 6', 'Next ' + nhan.toLowerCase(), function () { sp.go('>'); }));
    goc.insertAdjacentElement('afterend', hang);

    // `index` của Splide ở chế độ loop luôn là chỉ số thẻ THẬT, không phải bản
    // nhân bản — nên chấm không cần quy đổi gì.
    //
    // KHÔNG đọc `sp.index` trước `mount()`. Getter đó đi qua
    // `Components.Controller`, mà Components chỉ tồn tại sau khi mount — đọc sớm
    // thì ném `Cannot read properties of undefined (reading 'Controller')`, lỗi
    // đó văng ra trước dòng `sp.mount()` nên slider không dựng được gì cả.
    // Trạng thái ban đầu để sự kiện `mounted` lo, nó chạy đúng một lần.
    sp.on('mounted move', function () { danhDau(sp.index); });
  }

  function dung(goc, rieng, nhan) {
    if (goc.dataset.lbSplide === 'on') return;
    if (typeof window.Splide !== 'function') return;
    var soThe = goc.querySelectorAll('.splide__slide').length;
    if (soThe < 2) return;
    goc.dataset.lbSplide = 'on';
    var sp = new window.Splide(goc, tuyChon(rieng));
    // Dựng điều khiển TRƯỚC mount vì phải gắn `on('mounted')` trước khi nó bắn;
    // nhưng bên trong tuyệt đối không chạm vào API cần Components.
    dungDieuKhien(sp, goc, soThe, nhan);
    sp.mount();
  }

  function init() {
    DAI.forEach(function (d) {
      document.querySelectorAll(d.goc).forEach(function (goc) {
        dung(goc, d.rieng, d.nhan);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
